export default __webpack_public_path__ + "static/media/4e2829784101bef84a614145f0151160.svg";